// Ported (trimmed) from LC2 (src/commons/constants/stylingConstants.js) — only the pieces
// needed so far.
export const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US').format(number);
};
